import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';
import { INSPECTION_EVALUATIONS_ENDPOINTS } from 'src/app/core/api/endpoints/inspection-evaluations.endpoints';

@Injectable({
  providedIn: 'root'
})
export class InspectionEvaluationsService {
  private api = inject(ApiService);

  createInspectionEvaluation(data): Observable<any> {
    return this.api.post(INSPECTION_EVALUATIONS_ENDPOINTS.V1.EVALUATION_INSPECTION, data);
  }

  getProjectServices(contractID): Observable<any> {
    return this.api.get<any>(INSPECTION_EVALUATIONS_ENDPOINTS.V1.CONTRACT_DYNAMIC_SERVICES(contractID));
  }

  getInspectionEvaluations(params): Observable<any> {
    return this.api.get<any>(INSPECTION_EVALUATIONS_ENDPOINTS.V1.EVALUATION_INSPECTION, {params});
  }

  getInspectionEvaluationByID(id): Observable<any> {
    return this.api.get<any>(INSPECTION_EVALUATIONS_ENDPOINTS.V1.EVALUATION_INSPECTION_DETAIL(id));
  }

  putInspectionEvaluation(id, data): Observable<any> {
    return this.api.put<any>(INSPECTION_EVALUATIONS_ENDPOINTS.V1.EVALUATION_INSPECTION_DETAIL(id), data);
  }

  getInspectionEvaluationTerms(inspectionEvaluationID): Observable<any> {
    return this.api.get<any>(INSPECTION_EVALUATIONS_ENDPOINTS.V1.EVALUATION_INSPECTION_TERMS(inspectionEvaluationID));
  }

  getCriteria() : Observable<any> {
    return this.api.get<any>(INSPECTION_EVALUATIONS_ENDPOINTS.V1.CRITERIA);
  }

  updateInspectionEvaluationTerm(termID, data): Observable<any> {
    return this.api.put<any>(INSPECTION_EVALUATIONS_ENDPOINTS.V1.EVALUATION_INSPECTION_TERM_CRITERIA(termID), data);
  }

  deleteEvaluations(evaluationIds): Observable<any> {
    return this.api.delete(
      INSPECTION_EVALUATIONS_ENDPOINTS.V1.EVALUATION_INSPECTION,
      {
        body: evaluationIds,
      }
    );
  }
}
